import { useSelector } from "react-redux";
import { AgGridReact } from 'ag-grid-react';
import './ReturnsAndStatistics.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const PerformanceTab = ({CalendarExcel}) => { 

  const Gstate = useSelector(state => { return state; }) || {};

  const performanceCalendarYearsData = Gstate.ReturnsGridData.PerformanceCalendarYearsData;
  const TrailingPerformanceData = Gstate.ReturnsGridData.TrailingPerformanceData;

  //Performance Calendar Grid
  const PerfCalendarYrs = performanceCalendarYearsData?.CalendarYrs || [];

  const uniqueCalendarYears = Array.from(
    new Set(PerfCalendarYrs.flatMap((item) => item.Years.map((Year) => Year.Year)))
  );

  const calendarYearsData = PerfCalendarYrs.map(item => {
    const calendarYearsData = {
      Average: formatValue(item.Average, getFormat(item.name)),
      StatDesc: item.StatDesc,
    };

    item.Years.forEach(Year => {
      const format = getFormat(item.name);
      calendarYearsData[`Year${Year.Year}`] = formatValue(Year.Value, format);
    });

    return calendarYearsData;
  });

  function getFormat(StatDesc) {
    if (StatDesc === 'Rate of Return' || StatDesc === 'Max Annnual Run-up' || StatDesc === 'Max Annual Drawdown' || 
        StatDesc === 'Cumulative Total Return' || StatDesc === 'Compounded Annualized Return') {
      return 'percentage';
    }
    else if (StatDesc === 'Year End Assets (MM)') {
      return 'currency';
    }
    else if (StatDesc === 'Year End Growth of 1,000') {
      return 'number';
    }
    else if (StatDesc === '# of Profitable Months' || StatDesc === '# of Losing Months') {
      return 'roundNumber';
    }
    else {
      return 'default';
    }
  }

  function formatValue(value, format) {

    if (format === 'percentage') {
      return value !== null ? `${(value * 100).toFixed(2)}%` : '';
    }
    else if (format === 'currency') {
      return value !== null ? `$${value}` : '';
    }
    else if (format === 'number') {
      return value !== null ? value.toFixed(2) : '';
    }
    else if (format === 'roundNumber') {
      return value !== null ? Math.round(value) : '';
    }
    else {
      return value;
    }
  }
  const perfCalendarcolumnDefs = [

    { headerName: 'Name', field: 'StatDesc', pinned: 'left', width: 200, },
    ...uniqueCalendarYears.map((Year) => ({
      headerName: `${Year}`,
      field: `Year${Year}`,
      valueFormatter: ({ value, data }) => {
        const format = getFormat(data.StatDesc);
        return formatValue(value, format);
      },
      cellStyle: ({ value }) => ({ textAlign: 'right', color: (value < 0) ? 'red' : '' }),
      width: 100,
    })),
    { headerName: 'Average', field: 'Average',
    valueFormatter: ({ value, data }) => {
      const format = getFormat(data.StatDesc);
      return formatValue(value, format);
    }, 
    cellStyle: ({ value }) => ({textAlign: 'right', color: (value < 0) ? 'red' : ''}),
    width: 90,
   },
  ];

//Trailing performance
const trailingData = TrailingPerformanceData?.TrailingPerfGrid || [];
 const uniquetrailingPeriods = Array.from(
    new Set(trailingData.flatMap((item) => item.Periods.map((PeriodDesc) => PeriodDesc.PeriodDesc)))
  );

  const trailingPerfData = trailingData.map(item => {
    const trailingPerfData = {
      StatDesc: item.StatDesc,
    };

    item.Periods.forEach(Period => {
      const format = getFormat(item.name);
      trailingPerfData[`PeriodDesc${Period.PeriodDesc}`] = formatValue(Period.Value, format);
    });

    return trailingPerfData;
  });

const  trailingColumnDefs = [
    
  { headerName: 'Name', field: 'StatDesc', pinned: 'left', width: 250, },
  ...uniquetrailingPeriods.map((PeriodDesc) => ({
    headerName: `${PeriodDesc}`,
    field: `PeriodDesc${PeriodDesc}`,
    valueFormatter: ({ value, data }) => {
      const format = getFormat(data.StatDesc);
      return formatValue(value, format);
    }, 
    cellStyle: ({ value }) => ({ textAlign: 'right', color: (value < 0) ? 'red' : '' }) ,
    width: 130,
  })),
 
];
 
const defaultColDef = {
  sortable: false, filter: false, suppressMovable: true,resizable:true
}

  return (
    <>
      <div className="ag-theme-alpine" style={{ width: '100%', height: '360px' }}>   
      <h6>Calendar Years</h6>                         
          <AgGridReact
              columnDefs={perfCalendarcolumnDefs}
              rowData={calendarYearsData}
              defaultColDef={defaultColDef}     
              onGridReady={params => {
                CalendarExcel.current = params.api;
              }}                 
          />
      </div>
      <br></br>
      <div className="ag-theme-alpine" style={{ width: '100%', height: '180px' }}>  
          <h6>Trailing Performance</h6>                           
              <AgGridReact
                  columnDefs={trailingColumnDefs}
                  rowData={trailingPerfData}
                  defaultColDef={defaultColDef}   
              />
          </div>
    </>
  )
}

export default PerformanceTab;
